

import { useState, useEffect, useRef } from "react";

export const useUniversalSearch = (disabled = false) => {
  const popupRef = useRef<HTMLDivElement | null>(null);
  const [isUniversalSearchOpen, setIsUniversalSearchOpen] = useState(false);
  // Ref mirror so the stable keydown handler can check openness without
  // re-subscribing per state change.
  const openRef = useRef(false);
  useEffect(() => {
    openRef.current = isUniversalSearchOpen;
  }, [isUniversalSearchOpen]);

  useEffect(() => {
    if (disabled) return;

    const handleShortcut = (e: KeyboardEvent) => {
      if (e.repeat) return;

      if ((e.ctrlKey || e.metaKey) && e.key === "k") {
        e.preventDefault();
        setIsUniversalSearchOpen((prevState) => !prevState);
      }

      if (e.key === "Escape" && openRef.current) {
        // Swallow: one Escape closes ONLY the search — without this it falls
        // through to the AI drawer/studio window handlers and closes both
        // (document bubble fires before window bubble).
        e.stopPropagation();
        setIsUniversalSearchOpen(false);
      }
    };

    document.addEventListener("keydown", handleShortcut);
    return () => document.removeEventListener("keydown", handleShortcut);
  }, [disabled]);

  return {
    popupRef,
    isUniversalSearchOpen,
    setIsUniversalSearchOpen,
  };
};
